// This is example of menu item without group for horizontal layout. There will be no children.

// assets
import ChromeOutlined from '@ant-design/icons/ChromeOutlined';
import HomeOutlined from '@ant-design/icons/HomeOutlined';
import MenuOutlined from '@ant-design/icons/MenuOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';
import CloudSyncOutlined from '@ant-design/icons/CloudSyncOutlined';
import CloudUploadOutlined from '@ant-design/icons/CloudUploadOutlined';
import SlidersOutlined from '@ant-design/icons/SlidersOutlined';

// icons
const icons = { ChromeOutlined, HomeOutlined, MenuOutlined};

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const samplePage = {
  id: 'group-pages',
  type: 'group',
  children: [
  {
    id: 'home',
    title: 'Home',
    type: 'item',
    url: '/home',
    icon: icons.HomeOutlined
  },
  {
    id: 'connectors',
    title: 'Connectors',
    type: 'item',
    url: '/connectors',
    icon: icons.MenuOutlined
  },
  {
    id: 'extract',
    title: 'Extract',
    type: 'item',
    url: '/extract',
    icon: AppstoreOutlined
  },
  {
    id: 'transform',
    title: 'Transform',
    type: 'item',
    url: '/transform',
    icon: SlidersOutlined
  },
  {
    id: 'load',
    title: 'Load',
    type: 'item',
    url: '/load',
    icon: CloudUploadOutlined
  },
  {
    id: 'migrate',
    title: 'Migrate',
    type: 'item',
    url: '/migrate',
    icon: CloudSyncOutlined
  },
  {
    id: 'visualize',
    title: 'Visualize',
    type: 'item',
    url: '/dashboard',
    icon: BarChartOutlined
  }
]
}

export default samplePage;
